import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import SingleCategoryTwo from '../../components/Category/SingleCategoryTwo';

import shapeImg from '../../assets/img/category/shape-1-1.png';
import titleImg from '../../assets/img/category/title.svg';
import { categoryIcons } from '../../data/images';

const iconImg1 = categoryIcons.banking;
const iconImg2 = categoryIcons.insurance;
const iconImg3 = categoryIcons.planning;
const iconImg4 = categoryIcons.diplomas;
const iconImg5 = categoryIcons.training;

const categories = [
  { icon: iconImg1, to: '/programs/bsc-banking-finance', title: 'Banking', subTitle: 'B.Sc. degree, 4 years', delay: '.3s' },
  { icon: iconImg2, to: '/programs/bsc-insurance-risk', title: 'Insurance', subTitle: 'B.Sc. degree, 4 years', delay: '.4s' },
  { icon: iconImg3, to: '/programs/bsc-regional-science-planning', title: 'Planning', subTitle: 'B.Sc. degree, 4 years', delay: '.5s' },
  { icon: iconImg4, to: '/programs?type=diploma', title: 'Diplomas', subTitle: 'Part-time, 1 year', delay: '.6s' },
  { icon: iconImg5, to: '/programs?type=short', title: 'Training', subTitle: '46 training programs', delay: '.7s' },
];

const Category = () => {
  return (
    <div className="it-category-4-area p-relative pt-120 pb-90">
      <div className="it-category-4-shape-1 d-none d-lg-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="it-category-4-title-wrap mb-60">
          <div className="row align-items-end">
            <div className="col-xl-6 col-lg-6 col-md-6">
              <SectionTitle
                itemClass="it-category-4-title-box"
                subTitleClass="it-section-subtitle-5 purple-2"
                subTitle="Study With Us"
                titleClass="it-section-title-3"
                title="Choose Your Path"
                titleImage={titleImg}
              />
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6">
              <div className="it-category-4-btn-box text-start text-md-end pt-25">
                <Link className="ed-btn-square purple-2" to="/program-types">
                  See All Programs
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row row-cols-xl-5 row-cols-lg-3 row-cols-md-3 row-cols-sm-2 row-cols-1">
          {categories.map((c) => (
            <div
              key={c.title}
              className="col mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay={c.delay}
            >
              <SingleCategoryTwo
                iconImage={c.icon}
                title={c.title}
                subTitle={c.subTitle}
                to={c.to}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Category;
